const listeners = new Map();

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAlertOptions { }
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function addListener(name: string, func: any): void {
	listeners.set(name, func);
}

export const showAlert = (options: IAlertOptions): unknown => {
	const func = listeners.get('showAlert');
	return func && func(options);
};

export const showAlertLong = (options: IAlertOptions): unknown => {
	const func = listeners.get('showAlertLong');
	return func && func(options);
};

export const hideAlert = (options: IAlertOptions): unknown => {
	const func = listeners.get('hideAlert');
	return func && func(options);
};

export const noConnectionAlert = (): unknown => {
	const func = listeners.get('noConnectionAlert');
	return func && func();
};

export const showAlertOpentokMuted = (options: IAlertOptions): unknown => {
	const func = listeners.get('showAlertOpentokMuted');
	return func && func(options);
};

export const showAnnouncement = (options: IAlertOptions): unknown => {
	const func = listeners.get('showAnnouncement');
	return func && func(options);
};

export const clearListeners = (): void => {
	listeners.clear();
};

export const ALERT_TYPES = {
	WARNING: 1,
	ERROR: 2,
	NEUTRAL: 3,
	POSITIVE: 4,
	CHAT: 5,
	ANNOUNCE: 6,
};

Object.freeze(showAlert);
Object.freeze(showAlertLong);
Object.freeze(showAlertOpentokMuted);
Object.freeze(hideAlert);
Object.freeze(noConnectionAlert);
Object.freeze(clearListeners);
